module.exports = __webpack_public_path__ + "img/essenza.00ec35a6.png";